import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

/**
 * A simple component that renders a bootstrap-compatible button.
 */
export default function Button(props) {
  const className = props.action.buttonClass
    ? `btn btn-${props.action.buttonClass}`
    : "btn btn-default";

  return (
    <button type="button" className={className} onClick={props.action.onClick}>
      <FormattedMessage id={props.action.message} />
    </button>
  );
}

Button.propsTypes = {
  /**
   * An object containing the following keys:
   * buttonClass - (Optional) an additional bootstrap btn-* class to apply to the button
   * message - (Required) The text of the button
   * onClick - (Optional) A callback fired when the button is clicked
   */
  action: PropTypes.object.isRequired
};
